import randomFeedback from "../../funcs/random_feedback";
import { SVGButtonModal, CompHTML, SVGCheckedAnswer } from "../widgets/index";
import { explanation_svg } from "../../svg/index.js";
import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { 
	recordItem 
} from "../../store/activityStateReducers";

const CompRadios = ({
	answer_index,
	item_number,
	instant_feedback_bool,
	validation_js,
	data_js
}) => {
	const dispatch = useDispatch();

	// Each radio item needs to share a name property, which
	// we assign randomly
	const item_id =
		"radios_" +
		((Date.now() + Math.random()) * Math.random())
			.toString()
			.replace(/\./g, "");

	const {
		prompt_s,
		options_js_a,
		value_init,
		options_answer_n,
		explanation
	} = data_js;

	const [response, setResponse] = useState(undefined);
	const [feedback, setFeedback] = useState("");
	const [checked_answer_value, setCheckedAnswerValue] = useState("hide");

	const [style_feedback, setStyleFeedback] = useState({});

	const handleChange = (event) => {
		setResponse(parseInt(event.target.value));
	};

	// ------------------------  check answer and give feedback ---------------
	useEffect(() => {
		// Regardless of whether any rdio button is selected,
		// e.g., response could be undefined
		// we create a boolean to filter actions for when/if the
		// correct response is chosen
		const is_correct_bool = response === options_answer_n ? true : false;

		// If there is a response selected, we already know if
		// it is correct/incorrect.
		// (1) Calc score
		// (2) Record score to store
		if (options_js_a[response] !== undefined) {
			// (1)
			const score = is_correct_bool ? 1 : 0;
			let js = { answer_index, score };
			js["response"] = options_js_a[response].value.replace(/<[^>]+>/g, "");
			js["correct"] = is_correct_bool;
			// (2)
			dispatch(recordItem(js));
		}

		// If instant feedback is true ...
		// ... and nothing is selected
		// (3.1) Update SVGCheckedAnswer to none
		// (3.2) Show no textual feedback
		// (3.3) Set the feedback style div to no style
		// ... something is selected...
		// (4.1) Update SVGCheckedAnswer to correct|incorrect
		// (4.2) IF AVAILABLE - Provide positive/negative, else select a random phrase
		// (4.3) set styles the feedback style div
		// If instant feedback is false ...
		// (5.1) Update SVGCheckedAnswer to none
		// (5.2) Show no textual feedback
		// (5.3) Set the feedback style div to no style
		let fb;
		let checked_answer_val;
		let st_feedback;
		if (instant_feedback_bool) {
			if (response === undefined) {
				// (3.1)
				checked_answer_val = "none";
				// (3.2)
				fb = "";
				//  (3.3)
				st_feedback = {};
			} else {
				if (is_correct_bool) {
					// (4.1)
					checked_answer_val = "correct";
					// (4.2)
					if (
						validation_js.feedback_positive === "none" ||
						validation_js.feedback_positive === undefined
						) {
						fb = randomFeedback.getPositive;
					} else {
						fb = validation_js.feedback_positive;
					}
				} else {
					// (4.1)
					checked_answer_val = "incorrect";
					// (4.2)
					if (
						validation_js.feedback_negative === "none" ||
						validation_js.feedback_negative === undefined
						) {
						fb = randomFeedback.getNegative;
					} else {
						fb = validation_js.feedback_negative;
					}
				}
				//  (4.3)
				st_feedback = {
					borderStyle: "solid",
					borderColor: "#6c757d59",
					borderWidth: "thin",
					backgroundColor: "#6c757d05"
				};
			}
		} else {
			// (5.1)
			checked_answer_val = "none";
			// (5.2)
			fb = "";
			//  (5.3)
			st_feedback = {};
		}
		setCheckedAnswerValue(checked_answer_val);
		setFeedback(fb);
		setStyleFeedback(st_feedback);
	}, [
		instant_feedback_bool,
		validation_js,
		response,
		options_answer_n,
		options_js_a,
		answer_index,
		dispatch
	]);
	// ------------------------------------------------------------------------

	// --------------- correct/incorrect and provide explanations -------------
	const correct_bool = useSelector((state) => {
		let res;
		try {
			res = state.activityStates.results_a[answer_index].correct;
		} catch (e) {
			res = false;
		}
		return res;
	});
	const saved_bool = useSelector((state) => {
		let res;
		try {
			res = state.activityStates.saved_bool;
		} catch (e) {
			res = false;
		}
		return res;
	});
	const items_show_checkanswer_bool = useSelector((state) => {
		let res;
		try {
			res = state.activityStates.items_show_checkanswer_bool;
		} catch (e) {
			res = false;
		}
		return res;
	});
	const items_show_explanation_bool = useSelector((state) => {
		let res;
		try {
			res = state.activityStates.items_show_explanation_bool;
		} catch (e) {
			res = false;
		}
		return res;
	});	
	const [checked_answer_jsx, setCheckedAnswerJSX] = useState(<></>);
	useEffect(() => {
		let jsx_a = [
			<span key={1}></span>,
			<span key={2}> </span>,
			<span key={3}></span>
		];
		if (!instant_feedback_bool) {
			if (items_show_checkanswer_bool) {
				const correct_response = options_js_a[options_answer_n].value.replace(
					/<[^>]+>/g,
					""
				);
				jsx_a[0] = (
					<span key={1}>
						<SVGCheckedAnswer
							value={correct_bool ? "correct" : "incorrect"}
							height={30}
						/>
						{correct_bool ? (
							<></>
						) : (
							<span style={{ marginRight: 10 }}>
								&nbsp;&rarr;&nbsp;{correct_response}
							</span>
						)}
					</span>
				);
			}
		}
		if (items_show_explanation_bool) {
			jsx_a[2] = (
				<span key={3}>
					{explanation === undefined ? (
						<></>
					) : (
						<SVGButtonModal
							svg={explanation_svg}
							tooltip={"See explanation"}
							modal_html={explanation}
						/>
					)}
				</span>
			);
		}
		let jsx;
		if (items_show_checkanswer_bool || items_show_explanation_bool) {
			jsx = <>{jsx_a}</>;
		} else {
			jsx = <></>;
		}
		setCheckedAnswerJSX(jsx);
	}, [
		items_show_checkanswer_bool,
		items_show_explanation_bool,
		correct_bool,
		instant_feedback_bool,
		options_js_a,
		options_answer_n,
		explanation,
		saved_bool
	]);
	// ------------------------------------------------------------------------
	
	return (
		<div
			style={{
				marginTop: 30,
				display: "grid",
				gridGap: 12,
				// justifyContent: "start",
				gridTemplateColumns: "75% 1% auto"
			}}
		>
			<div style={{ gridColumnEnd: "span 3" }}>
				<span className="prompt">
					<b>{item_number}.</b> {checked_answer_jsx}
					<CompHTML html={prompt_s} />
				</span>
			</div>
			<div>
				{options_js_a.map((elem, i) => {
					return (
						<div key={i + 1} className="form-check">
							<input
								onChange={handleChange}
								className="form-check-input"
								type="radio"
								name={item_id}
								value={i}
								defaultChecked={i === value_init && true}
							/>
							<label className="form-check-label">
								<CompHTML html={elem.value} />
								{elem.label !== "" && (
									<CompHTML style_js={{ marginLeft: 10 }} html={elem.label} />
								)}
							</label>
						</div>
					);
				})}
			</div>
			<div style={{ display: instant_feedback_bool ? "inline" : "none" }}>
				<SVGCheckedAnswer value={checked_answer_value} />
			</div>
			<div style={style_feedback}>
				<span>{feedback}</span>
			</div>
		</div>
	);
};

export default CompRadios;

/*

<CompRadios {...props_js} />

{
	"definitions_js": {
		"type": "radios",		
	},
	"validation_js": {
		"type": "regex",
		"required": "^.+",
		"feedback_": "You must provide a response."
	},
	"data_js": {
		"prompt_s": "Type of degree:",
		"options_js_a": [
			{"value": "True", "label": ""},
			{"value": "False", "label": ""}
		],
		"value_init": "",
		"options_answer_n": 0
	}
}
*/
